import React from "react";
import { Phone, HelpCircle } from "lucide-react";
import { CONTACT } from "../mock";

const GUIDE_QUESTIONS = [
  "What to see in Munnar for two days?",
  "Is Munnar safe for couples?",
  "Is Munnar safe for solo travellers / solo female travellers?",
  "Munnar 2-day / 3-day itinerary?",
  "Best time to visit Munnar (weather by month)?",
  "Kochi to Munnar cab fare and distance?",
  "How to reach Munnar from Kochi / Cochin airport?",
  "Which is the nearest airport to Munnar?",
  "Kanan Devan Hills Tea Museum ticket price and timings?",
  "Top Station Munnar — best view time?",
  "Kolukkumalai sunrise jeep safari and trekking?",
  "Eravikulam National Park online booking and timings?",
  "Best things to do in Munnar?",
  "Famous waterfalls in Munnar (Ripple, Attukad, Lakkam, Nyayamakad)?",
  "Want to see the Neela Kurinji bloom? (Blooms once every 12 years — Neela means blue in Malayalam and Kurinji is the local name of the flower)",
];

const CALL_ANSWER = "Call Auracrest Haven on 9388881016 to get the answer for FREE";

const TravelGuide = () => {
  const telHref = `tel:${CONTACT.phone.replace(/[^+\d]/g, "")}`;
  return (
    <section id="travel-guide" className="py-20 md:py-28 bg-white" data-testid="travel-guide">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
            Munnar Travel Guide
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4 leading-tight">
            Your Free Munnar Trip Planner
          </h2>
          <p className="text-neutral-600 max-w-3xl mx-auto leading-8">
            Got questions about planning your Munnar trip? Our local hosts know the hills inside out —
            and we're happy to help you plan, free of charge. Just give us a call.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {GUIDE_QUESTIONS.map((q, i) => (
            <a
              key={i}
              href={telHref}
              data-testid={`guide-question-${i}`}
              className="group bg-neutral-50 hover:bg-[#e3faf7] border border-neutral-200 hover:border-[#17a89b] rounded-2xl p-6 transition-colors"
            >
              <div className="flex items-start gap-3 mb-3">
                <HelpCircle className="w-5 h-5 text-[#17a89b] shrink-0 mt-0.5" />
                <h3 className="text-base font-bold text-neutral-900 leading-snug">{q}</h3>
              </div>
              <p className="flex items-center gap-2 text-sm font-semibold text-[#17a89b] pl-8">
                <Phone className="w-4 h-4" />
                {CALL_ANSWER}
              </p>
            </a>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={telHref}
            data-testid="travel-guide-call-btn"
            className="inline-flex items-center gap-2 bg-[#17a89b] hover:bg-[#128a7f] text-white font-semibold px-8 py-4 rounded-md transition-colors text-lg"
          >
            <Phone className="w-5 h-5" /> Call {CONTACT.phone} — It's Free
          </a>
        </div>
      </div>
    </section>
  );
};

export default TravelGuide;
